

































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import Chart from "chart.js";
import { range } from "lodash";

export interface PieData {
  value: number;
  label: string;
}

@Component({
  name: "BiPieChart",
})
export default class BiPieChart extends Vue {
  @Ref("canvas") canvas!: HTMLCanvasElement;
  @Prop() title!: string;
  @Prop({ default: () => [] }) data!: PieData[];
  chart: Chart | null = null;

  colors = ["#4E6A7C", "#C3CACE", "#8D6E6F", "#D7E8C7"];
  currentSelectedPieceLabel: string = "";

  @Watch("data")
  async onData() {
    if (this.data && this.data.length) {
      await this.$nextTick();
      this.initChart();
    }
  }

  get loadingRange() {
    return range(0, 5);
  }

  percent(item: PieData) {
    const value = this.data.reduce((acc, curr) => acc + curr.value, 0);
    return `${Math.round((item.value / value) * 100)}%`;
  }

  isSelected(label: string) {
    return label.toLowerCase() === this.currentSelectedPieceLabel.toLowerCase();
  }

  initChart() {
    const data = {
      datasets: [
        {
          data: this.data.map(({ value }) => value),
          backgroundColor: ["#4E6A7C", "#C3CACE", "#8D6E6F", "#D7E8C7"],
          borderWidth: 5,
        },
      ],
      labels: this.data.map(({ label }) => label),
    };
    this.chart = new Chart(this.canvas, {
      type: "pie",
      data,
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20,
          },
        },
        events: [],
        legend: {
          display: false,
        },
        animation: {
          duration: 500,
          onComplete: function () {
            const {
              ctx,
              data: { datasets },
            } = this as any;
            ctx.font = Chart.helpers.fontString(20, "normal", "Gilroy");
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";

            if (!datasets || !datasets.length) {
              return;
            }

            datasets.forEach((dataset: any) => {
              for (let i = 0; i < dataset.data.length; i++) {
                const model =
                  dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                const total =
                  dataset._meta[Object.keys(dataset._meta)[0]].total;
                const mid_radius =
                  model.innerRadius +
                  (model.outerRadius - model.innerRadius) / 2;
                const start_angle = model.startAngle;
                const end_angle = model.endAngle;
                const mid_angle = start_angle + (end_angle - start_angle) / 2;
                const x = mid_radius * Math.cos(mid_angle);
                const y = mid_radius * Math.sin(mid_angle);

                ctx.fillStyle = "#ffffff";
                const percent = Math.round((dataset.data[i] / total) * 100);
                //Don't Display If Legend is hide or value is 0

                if (
                  dataset.data[i] != 0 &&
                  dataset._meta[Object.keys(dataset._meta)[0]].data[i].hidden !=
                    true
                ) {
                  // Display percent in another line, line break doesn't work for fillText
                  ctx.fillText(
                    percent < 6 ? "" : `${percent}%`,
                    model.x + x,
                    model.y + y + 15
                  );
                }
              }
            });
          },
        },
      },
    });
  }

  onClick(event: MouseEvent) {
    if (
      !this.chart ||
      !this.chart.data ||
      !this.chart.data.labels ||
      !this.chart.options.animation
    ) {
      return;
    }

    const addRadiusMargin = 15;
    const activePoints = this.chart.getElementsAtEvent(event) as any[];
    if (!activePoints.length) {
      return (this.canvas.style.cursor = "default");
    }

    this.canvas.style.cursor = "pointer";

    this.chart.options.animation.duration = 0;
    const clickedElementIndex = activePoints[0]["_index"];
    const clickedLabel = this.chart.data.labels[clickedElementIndex] as string;

    if (
      clickedLabel.toUpperCase() ===
      this.currentSelectedPieceLabel.toUpperCase()
    ) {
      return;
    }

    this.currentSelectedPieceLabel = clickedLabel.toUpperCase();
    (this.chart as any).outerRadius = (this.chart as any).outerRadius;
    this.chart.update();

    activePoints[0]["_model"].outerRadius =
      (this.chart as any).outerRadius + addRadiusMargin;
    this.chart.render({ duration: 0, lazy: false });
  }
}
